import { Additives } from './Additives';
import { AlcoholPercentage } from './AlcoholPercentage';
import { Allergens } from './Allergens';
import { Availability } from './Availability';
import { Brand } from './Brand';
import { BundleOffer } from './BundleOffer';
import { Caffeine } from './Caffeine';
import { CatalogProduct } from './CatalogProduct';
import { Category } from './Category';
import { CountryOfOrigin } from './CountryOfOrigin';
import { CourierRestrictions } from './CourierRestrictions';
import { CurrentAmount } from './CurrentAmount';
import { DeliveryMethods } from './DeliveryMethods';
import { DepositOption } from './DepositOption';
import { Description } from './Description';
import { DietaryPreferences } from './DietaryPreferences';
import { Discount } from './Discount';
import { DistributorInformation } from './DistributorInformation';
import { Enabled } from './Enabled';
import { ExternalHyperlink } from './ExternalHyperlink';
import { Gtin } from './Gtin';
import { Images } from './Images';
import { Ingredients } from './Ingredients';
import { InventoryStock } from './InventoryStock';
import { InventoryType } from './InventoryType';
import { ItemType } from './ItemType';
import { ItemVisibility } from './ItemVisibility';
import { LimitedQuantity } from './LimitedQuantity';
import { MandatoryWarnings } from './MandatoryWarnings';
import { MerchantSku } from './MerchantSku';
import { MoreInformation } from './MoreInformation';
import { Name } from './Name';
import { NutritionFacts } from './NutritionFacts';
import { PerPurchase } from './PerPurchase';
import { PosId } from './PosId';
import { Price } from './Price';
import { ProducerInformation } from './ProducerInformation';
import { ProductHierarchy } from './ProductHierarchy';
import { RestrictedItem } from './RestrictedItem';
import { UnitDetails } from './UnitDetails';
import { UsageInstructions } from './UsageInstructions';
import { Vat } from './Vat';

export const Fields = {
  Additives,
  AlcoholPercentage,
  Allergens,
  Availability,
  Brand,
  BundleOffer,
  Caffeine,
  CatalogProduct,
  Category,
  CountryOfOrigin,
  CourierRestrictions,
  CurrentAmount,
  DeliveryMethods,
  DepositOption,
  Description,
  DietaryPreferences,
  Discount,
  DistributorInformation,
  Enabled,
  ExternalHyperlink,
  Gtin,
  Images,
  Ingredients,
  InventoryStock,
  InventoryType,
  ItemType,
  ItemVisibility,
  LimitedQuantity,
  MandatoryWarnings,
  MerchantSku,
  MoreInformation,
  Name,
  NutritionFacts,
  PerPurchase,
  PosId,
  Price,
  ProducerInformation,
  ProductHierarchy,
  RestrictedItem,
  UnitDetails,
  UsageInstructions,
  Vat,
};
